<template>
  <v-container  class="step">
    <v-row  justify="center" class="full-height">
      <v-col cols="12" class="s11-container">
          <div class="s11-sub-container">
              <p class="s11-title"> <span class="underline">Point</span> {{$t("_s11_txt_1")}}：</p>
              <div class="s11-txt" ref="typed2">
                <p
                  data-aos='fade-down'
                  data-aos-delay="350"
                  data-aos-duration="2000"
                  data-aos-mirror="true"
                  data-aos-once="false"
                >
                  {{$t("_s11_txt_2")}}
                </p>
                <p
                  data-aos='fade-down'
                  data-aos-delay="550"
                  data-aos-duration="2000"
                  data-aos-mirror="true"
                  data-aos-once="false"
                >
                  {{$t("_s11_txt_3")}}
                </p>
                <p
                  data-aos='fade-down'
                  data-aos-delay="750"
                  data-aos-duration="2000"
                  data-aos-mirror="true"
                  data-aos-once="false"
                >
                  {{$t("_s11_txt_4")}}
                </p>
              </div>
          </div>
          </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
.s11-container {
    width: 100%; /* Chiều rộng của div */
    height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
    display: flex;
    align-items: center;
    flex-direction: row;
}
.s11-sub-container {
  width: 100%;
}
.s11-title {
    font-family: "BodoniModa-Italic";
    font-size: 25px;
    font-weight: 600;
    text-transform: uppercase;
    padding-bottom: 30px;
}
.underline {
  text-decoration: underline;
}
.s11-txt {
  height: 250px;
  width: 90%;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.s11-txt {
  line-height: 2;
  white-space: pre-line;
}
@media (max-width: 960px) {
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    margin-top: 20%;
  }
  .full-height {
    height: unset!important;
    width: 100%;
    padding: unset!important;
  }
  .s11-txt {
    width: 90%;
  }
}
@media (max-width: 600px) {
  .s11-txt {
    height: fit-content;
    width: 98%;
  }
}
</style>